<script setup lang="ts">
import {ref} from 'vue'
import '@/assets/styles/contact.css'
import axios from 'axios'

const submitted = ref(false)
const error = ref('')
const showToast = ref(false)
const toastMessage = ref("")
const showConfirmToast = ref(false)

const form = ref({
  name: '',
  email: '',
  message: '',
  data: false
})

const submitForm = async () => {

  submitted.value = false
  error.value = ''

  try {

    const res = await axios.post("/api/contact", {
      name: form.value.name,
      email: form.value.email,
      message: form.value.message
    })

    submitted.value = true

    form.value = {
      name: "",
      email: "",
      message: "",
      data: false
    }

    console.log("Antwort:", res.data)

  } catch (err) {

    error.value = 'Fehler beim Versenden'
    console.error(err)

  }
}

const abfrage = () => {
  showConfirmToast.value = true
}

const confirmSubmission = async () => {

  await submitForm()

  toastMessage.value = "Ihre Kontaktanfrage wurde erfolgreich übermittelt."
  showToast.value = true

  setTimeout(() => showToast.value = false, 4000)

  showConfirmToast.value = false
}

const cancelSubmission = () => {
  showConfirmToast.value = false
}
</script>

<template>

  <section class="contact-page">

    <!-- Toast -->
    <div v-if="showToast" class="toast">
      {{ toastMessage }}
    </div>

    <!-- Confirm -->
    <div v-if="showConfirmToast" class="confirm-toast-overlay">

      <div class="confirm-toast-box">

        <p>
          Sind Sie sicher, dass Sie die Anfrage absenden möchten?
        </p>

        <div class="confirm-toast-buttons">

          <button
              class="confirm-btn"
              @click="confirmSubmission"
          >
            Ja
          </button>

          <button
              class="cancel-btn"
              @click="cancelSubmission"
          >
            Abbrechen
          </button>

        </div>

      </div>

    </div>

    <!-- Header -->
    <div class="contact-header">

      <span class="contact-badge">
        Kontakt
      </span>

      <h1>
        Wir sind für Sie da
      </h1>

      <p>
        Kontaktieren Sie uns für Fragen,
        Beratung oder weitere Informationen.
      </p>

    </div>

    <!-- Content -->
    <div class="contact-wrapper">

      <!-- Infos -->
      <div class="contact-info">

        <div class="info-card">

          <h3>Standort 1 – Verwaltung</h3>

          <p>Am Niedwald 53</p>
          <p>65933 Frankfurt am Main</p>

          <span>
            Postanschrift und Schriftverkehr
          </span>

        </div>

        <div class="info-card">

          <h3>Standort 2 – Servicebüro</h3>

          <p>Herxheimerstraße 17</p>
          <p>60326 Frankfurt am Main</p>

          <span>
            Kundenempfang und Beratung
          </span>

        </div>

        <div class="info-card">

          <h3>Telefon</h3>

          <a href="tel:+4906975009899">
            069 7500 9899
          </a>

        </div>

      </div>

      <!-- Formular -->
      <div class="contact-form-card">

        <form
            @submit.prevent="abfrage"
            class="contact-form"
        >

          <div class="form-group">
            <label>Name</label>

            <input
                type="text"
                v-model="form.name"
                placeholder="Ihr Name"
                required
            />
          </div>

          <div class="form-group">
            <label>E-Mail</label>

            <input
                type="email"
                v-model="form.email"
                placeholder="Ihre E-Mail"
                required
            />
          </div>

          <div class="form-group">
            <label>Nachricht</label>

            <textarea
                v-model="form.message"
                placeholder="Ihre Nachricht"
                required
            />
          </div>

          <label class="checkbox-label">
            <input
                type="checkbox"
                v-model="form.data"
                required
            />
            <span class="custom-checkbox"></span>

            <span class="checkbox-text">
              Ich stimme der Verarbeitung meiner Daten gemäß
              <a href="/datenschutz" target="_blank">Datenschutzerklärung</a>
              zu.
              </span>
          </label>
          
          <button type="submit">
            Nachricht senden
          </button>

        </form>

      </div>

    </div>

  </section>

</template>

<style scoped>
</style>